<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <!-- Brand logo-->
      <b-link class="brand-logo">
        <!-- <h2 class="brand-text text-primary ml-1">CORSYMO</h2> -->
      </b-link>

      <b-col lg="7" class="d-none d-lg-flex align-items-center p-5">
        <div
          class="w-100 d-lg-flex align-items-center justify-content-center px-5"
        >
          <b-img width="450" fluid :src="imgUrl" alt="Login V2" />
        </div>
      </b-col>

      <b-col lg="5" class="d-flex align-items-center auth-bg px-0 p-lg-5">
        <!-- <b-col
          sm="8"
          md="6"
          lg="12"
          class="d-flex px-xl-2 pt-5 pt-xl-0 mx-auto col-sm-8 col-md-6 col-lg-12 border-bottom border-gray-500"
        >
          <b-img
            class="w-50 align-items-center justify-content-center px-5 mx-auto img-fluid mb-3"
            width="20"
            fluid
            :src="imgUrl"
            alt="Login V2"
          />
          <b-card-text class="card-text mt-2 mx-auto mb-3">
            CORSYMO Praesens-Film
          </b-card-text>
        </b-col> -->
        <b-col sm="8" md="6" lg="12" class="px-xl-2 pt-5 pt-xl-0 mx-auto mt-3">
          <b-card-title title-tag="h2" class="font-weight-bold mb-1">
            Welcome to Corsymo! 👋
          </b-card-title>
          <b-card-text class="mb-2">
            Please sign-in to your account.
          </b-card-text>

          <!-- form -->
          <validation-observer ref="loginValidation">
            <b-form class="auth-login-form mt-2" @submit.prevent>
              <!-- email -->
              <b-form-group label="Email" label-for="login-email">
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  rules="required|email"
                >
                  <b-form-input
                    id="login-email"
                    v-model="form.email"
                    :state="errors.length > 0 ? false : null"
                    name="login-email"
                    placeholder="john@example.com"
                    :disabled="is_otp_send || is_email_verification_otp"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group>
                <!-- <b-form-group v-if="!is_forget_password || is_otp_send"> -->
                <div
                  v-if="!is_forget_password || is_otp_send"
                  class="d-flex justify-content-between"
                >
                  <label for="login-password">{{
                    !is_forget_password ? "Password" : "New Password"
                  }}</label>
                  <!-- <b-link :to="{ name: 'ForgotPassword' }"> -->
                  <b-card-text
                    class="cursor-pointer"
                    @click="handle_forgot_password()"
                    v-if="
                      !is_forget_password || !is_otp_send
                    "
                  >
                    <small><u>Forgot Password?</u></small>
                  </b-card-text>
                  <!-- </b-link> -->
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="Password"
                  :rules="{
                    required: true,
                    ...(is_forget_password ? { regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/ } : {})
                  }"
                  v-if="!is_forget_password || is_otp_send"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                  >
                    <!-- v-if="!is_forget_password || is_otp_send" -->
                    <b-form-input
                      id="login-password"
                      v-model="form.password"
                      :state="errors.length > 0 ? false : null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                      placeholder="············"
                      :disabled="is_email_verification_otp"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ is_forget_password ? validatePassword(form.password) : errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-form-group v-if="is_otp_send || is_email_verification_otp " label="OTP" label-for="otp">
                <validation-provider #default="{ errors }" name="OTP">
                  <b-form-input
                    id="otp"
                    v-model="otp"
                    :state="errors.length > 0 ? false : null"
                    name="otp"
                    placeholder="******"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-card-text
                class="mt-2 cursor-pointer"
                v-if="is_forget_password || is_otp_send"
                @click="handle_back_to_login()"
              >
                <b><u>Back to Login?</u></b>
              </b-card-text>
              <b-button
                class="mt-2"
                type="submit"
                variant="primary"
                block
                @click="handle_submit"
              >
                {{
                  !is_email_verification_otp && !is_forget_password
                    ? "Log in"
                    : is_forget_password
                    ? is_otp_send
                      ? "Update Password"
                      : "Send OTP"
                    : "Verify"
                }}
              </b-button>
            </b-form>
          </validation-observer>

          <b-card-text class="text-center mt-2">
            <span
              >The login credentials are provided by the admin at CORSYMO
            </span>
          </b-card-text>
        </b-col>
      </b-col>
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */

import { ValidationProvider, ValidationObserver } from "vee-validate";
import VuexyLogo from "@core/layouts/components/Logo.vue";
import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BFormCheckbox,
  BCardText,
  BCardTitle,
  BImg,
  BForm,
  BButton,
} from "bootstrap-vue";
import { required, email } from "@validations";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import store from "@/store/index";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import * as AuthServices from "@/apiServices/AuthServices";
import { TokenService } from "@/apiServices/storageService";
import { password } from "@/@core/utils/validations/validations";

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    VuexyLogo,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      form: {
        status: "",
        password: "",
        email: "",
      },
      sideImg: require("@/assets/images/pages/corsymo_logo.png"),
      required,
      email,
      is_forget_password: false,
      is_otp_send: false,
      otp: null,
      is_email_verified: false,
      is_email_verification_otp:false,
    };
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === "dark") {
        this.sideImg = require("@/assets/images/pages/corsymo_logo.png");
        return this.sideImg;
      }
      return this.sideImg;
    },
  },
  methods: {
    validatePassword(password) {
      if(password === "") return "";
      if (!/[a-z]/.test(password)) return "Add a lowercase letter";
      if (!/[A-Z]/.test(password)) return "Add an uppercase letter";
      if (!/\d/.test(password)) return "Add a digit";
      if (!/[\W_]/.test(password)) return "Add a special character";
      if (password.length < 8) return "Use at least 8 characters";
      return "";
    },
    handle_forgot_password() {
      this.is_forget_password = true;
    },
    handle_back_to_login() {
      this.is_forget_password = false;
      this.is_otp_send = false;
    },
    Login() {
      this.$refs.loginValidation.validate().then(async (success) => {
        if (success) {
          try {
            const payload = {
              ...this.form,
              otp:this.otp,
            }
            const response = await AuthServices.Login(payload);
            if (response.data.status) {
              TokenService.saveToken(response.data.data.token);

              this.$store.commit("user/SET_USER_AUTHENTICATED", true);

              this.$toast({
                component: ToastificationContent,
                props: {
                  title: response.data.message || "Login Successful",
                  icon: "EditIcon",
                  variant: "success",
                },
              });
              this.$store.dispatch("user/setUserDetails");
              // this.$router.push({ name: "home" });
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: response.data.message || "Login Failure",
                  icon: "EditIcon",
                  variant: "failure",
                },
              });
            }
          } catch (error) {
            console.log("Error Login ", error);
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Server Error",
                icon: "EditIcon",
                variant: "failure",
              },
            });
          }
        }
      });
    },

    async send_otp() {
      try {
        // console.log('hh')
        const payload = {
          email: this.form.email,
        };
        const response = await AuthServices.send_otp(payload);
        if (response.data.status) {
          this.is_otp_send = true;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: response.data.message || "OTP send successfully",
              icon: "EditIcon",
              variant: "success",
            },
          });
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: response.data.message || "OTP failed to send",
              icon: "EditIcon",
              variant: "failure",
            },
          });
        }
      } catch (error) {
        console.log("Error Login ", error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Server Error",
            icon: "EditIcon",
            variant: "failure",
          },
        });
      }
    },
    async verify_otp_update_password() {
      try {
        // console.log('hh')
        const payload = {
          email: this.form.email,
          password: this.form.password,
          otp: this.otp,
        };
        const response = await AuthServices.verify_otp_update_password(payload);
        if (response.data.status) {
          this.is_forget_password = false;
          this.is_otp_send = false;
          // this.Login();
          this.$toast({
            component: ToastificationContent,
            props: {
              title: response.data.message || "Password Updated Successfully",
              icon: "EditIcon",
              variant: "success",
            },
          });
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: response.data.message || "failed to update password",
              icon: "EditIcon",
              variant: "failure",
            },
          });
        }
      } catch (error) {
        console.log("Error Login ", error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Server Error",
            icon: "EditIcon",
            variant: "failure",
          },
        });
      }
    },

    async verify_auth() {
      try {
        // console.log('hh')
        const payload = {
          email: this.form.email,
          password: this.form.password,
        };
        const response = await AuthServices.verify_auth(payload);
        if(response.data.status){
          if (response.data.data.session_expired) {
            this.is_email_verification_otp = true;
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.message || "OTP send successfully",
                icon: "EditIcon",
                variant: "success",
              },
            });
          } 
          else{
            this.Login();
          }
        }
        else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: response.data.message || "OTP failed to send",
              icon: "EditIcon",
              variant: "failure",
            },
          });
        }
      } catch (error) {
        console.log("Error Login ", error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Server Error",
            icon: "EditIcon",
            variant: "failure",
          },
        });
      }
    },

    async handle_submit() {
      // console.log('hfeiheifhei')
      if (!this.is_forget_password && this.is_email_verification_otp) {
        // console.log("Login", this.is_forget_password);
        await this.Login();
      } else if (this.is_forget_password && !this.is_otp_send) {
        // console.log("send_otp", this.is_otp_send);
        await this.send_otp();
      } else if (this.is_otp_send) {
        // console.log("verify_otp_update_password", this.is_otp_send);
        await this.verify_otp_update_password();
      } else if (!this.is_email_verification_otp) {
        // console.log("verify_auth", this.is_email_verification_otp);
        await this.verify_auth();
      }
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
</style>
